module.exports = __webpack_public_path__ + "img/home_img_part_culture.7c838a16.png";